import { memo } from 'react';

import { EMPTY_ARR } from '~/core/shared/constants';
import { AnyDocument } from '~/core/shared/types';
import { useDocumentDataView } from './hooks/useDocumentDataView';
import { HasManyHandler } from './HasManyHandler';
import { HasOneHandler } from './HasOneHandler';
import { DocumentDataViewProps } from './types';

const DocumentDataViewComponent = <DocumentDefinition,>({
  children,
  additionalValues,
  documentDefinition,
  documentDefinitionApi,
  existingValues,
  documentPath = EMPTY_ARR,
}: DocumentDataViewProps<DocumentDefinition>) => {
  const { documentTarget, hasMany } =
    useDocumentDataView<DocumentDefinition>(documentPath);

  if (!documentTarget) {
    return null;
  }

  if (hasMany) {
    return (
      <HasManyHandler<DocumentDefinition>
        additionalValues={additionalValues!}
        documentDefinition={documentDefinition}
        documentDefinitionApi={documentDefinitionApi}
        documentPath={documentPath}
        documentTarget={documentTarget as AnyDocument[]}
        existingValues={existingValues}
      >
        {children}
      </HasManyHandler>
    );
  }

  return (
    <HasOneHandler<DocumentDefinition>
      documentDefinition={documentDefinition}
      documentDefinitionApi={documentDefinitionApi}
      documentPath={documentPath}
      existingValues={existingValues}
    >
      {children}
    </HasOneHandler>
  );
};

export const DocumentDataView = memo(DocumentDataViewComponent);
